import { SET_CURRENT_PBI, CLEAR_CURRENT_PBI } from 'actions/payway';

const setCurrentPBI = pbi => dispatch => {
  dispatch({
    type: SET_CURRENT_PBI,
    payload: pbi,
  });
};

const clearCurrentPBI = () => dispatch => {
  dispatch({
    type: CLEAR_CURRENT_PBI,
  });
};

export { clearCurrentPBI };
export default setCurrentPBI;
